// Centralized GraphQL mutations for tracking events
import { gql } from "@apollo/client";

export const TRACK_POST_NEW_JOB_BUTTON = gql`
  mutation TrackPostNewJobButton($clientId: String) {
    trackPostNewJobButton(clientId: $clientId) {
      success
    }
  }
`;

export const TRACK_IMPORT_JOB_BUTTON = gql`
  mutation TrackImportJobButton($clientId: String) {
    trackImportJobButton(clientId: $clientId) {
      success
    }
  }
`;

export const TRACK_COPY_JOB_URL = gql`
  mutation TrackCopyJobUrl($clientId: String!, $jobId: String!, $jobTitle: String) {
    trackCopyJobUrl(clientId: $clientId, jobId: $jobId, jobTitle: $jobTitle) {
      success
    }
  }
`;

export const TRACK_OPEN_DEMO = gql`
  mutation TrackOpenDemo($clientId: String, $jobId: String) {
    trackOpenDemo(clientId: $clientId, jobId: $jobId) {
      success
    }
  }
`;

export const TRACK_VIEW_CANDIDATES = gql`
  mutation TrackViewCandidates($clientId: String!, $jobId: String!, $jobTitle: String, $candidatesCount: Int) {
    trackViewCandidates(clientId: $clientId, jobId: $jobId, jobTitle: $jobTitle, candidatesCount: $candidatesCount) {
      success
    }
  }
`;

export const TRACK_OPEN_CANDIDATE_PAGE = gql`
  mutation TrackOpenCandidatePage($clientId: String!, $jobId: String!, $applicationId: String!, $candidateId: String) {
    trackOpenCandidatePage(clientId: $clientId, jobId: $jobId, applicationId: $applicationId, candidateId: $candidateId) {
      success
    }
  }
`;

export const TRACK_LANDING_VISITED = gql`
  mutation TrackLandingVisited($clientId: String, $jobId: String, $referrer: String, $utmSource: String, $utmMedium: String, $utmCampaign: String) {
    trackLandingVisited(clientId: $clientId, jobId: $jobId, referrer: $referrer, utmSource: $utmSource, utmMedium: $utmMedium, utmCampaign: $utmCampaign) {
      success
    }
  }
`;

export const TRACK_LANDING_APPLY_NOW = gql`
  mutation TrackLandingApplyNow($clientId: String!, $jobId: String!, $jobTitle: String) {
    trackLandingApplyNow(clientId: $clientId, jobId: $jobId, jobTitle: $jobTitle) {
      success
    }
  }
`;

export const TRACK_INTERVIEW_INVITE_ACCEPTED = gql`
  mutation TrackInterviewInviteAccepted($applicationId: String!, $jobId: String!, $clientId: String!) {
    trackInterviewInviteAccepted(applicationId: $applicationId, jobId: $jobId, clientId: $clientId) {
      success
    }
  }
`;
